import { Module } from 'vuex';
import { RootState } from 'frontend/types';

export interface ClosedExperiment {
  name: string;
  winning_treatment: string;
  closed_date: string;
  closed_by: string;
}

export interface Experiments {
  experiments: ClosedExperiment[];
}

const experiments: Module<Experiments, RootState> = {
  namespaced: true,
  state: () => ({
    experiments: [] as ClosedExperiment[],
  }),
  mutations: {
    setValue(state: Experiments, value: Experiments): void {
      Object.assign(state, value);
    },
  },
};

export default experiments;
